<!--
 직접입력이 가능한 single select
------------------------------------

-->
<template>
    <div :class="classObject" :style="[defaultCssVariables, cssVariables]">
        <multiselect
            :value="multiselectValue"
            @input="updateValue"
            :options="options"
            label="text"

            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="선택하세요"

            @search-change="(val) => search = val"
        >
            <template
                slot="singleLabel"
                slot-scope="{ option }">
                {{ option.text }}
            </template>

            <template slot="noResult">
                <div class="uk-margin-small-bottom">
                    항목을 찾을 수 없습니다.
                </div>

                <button
                    class="uk-button uk-button-small uk-button-default uk-width-auto"
                    title="클릭하여, 새 항목을 입력합니다"
                    @click="addOptionBySearch"
                >
                    <i class="material-icons">add_box</i>
                    {{ search }}
                </button>
            </template>

        </multiselect>

        <!--
        <button
            class="uk-button uk-button-xsmall uk-button-default uk-width-auto"
            @click="add"
        >
            직접입력
        </button>
        -->
    </div>
</template>

<script>
    import InputBase from './base.vue';
    import Multiselect from 'vue-multiselect'

    export default {
        extends: InputBase,
        components: {
            Multiselect
        },
        data() {
            return {
                // 검색어
                search: null,
            };
        },
        computed: {
            /**
             * 멀티셀렉트 컴포넌트에 전달할 value
             *  - 현재 선택중인 object를 찾아서 반환한다
             * @return object
             */
            multiselectValue() {
                return _.find(this.options, (option) => {
                    return this.value == option.val;
                });

            },
        },
        methods: {
            /**
             * input 의 값이 변경되었음을 알리는 이벤트 발생
             *  - 리스너에 변경된 값을 인자로 전달
             * @param event vue 이벤트 객체
             * */
            updateValue: function (event) {
                // vue-multiselect 에서 이벤트가 발생한 경우에는 인자값으로 선택값이 바로 옴.
                let value = null;
                if (event) {
                    value = event.val;
                }
                this.$emit('update:value', value);
            },

            /**
             * 현재 search 값을 새 항목으로 추가합니다.
             */
            addOptionBySearch() {
                // 검색 값이 없음
                if (! this.search) {
                    return;
                }

                // 옵션추가
                const opt = {
                    text: this.search,
                    val: this.search,
                };
                this.options.push(opt);

                // 현재 선택값 변경처리
                this.updateValue(opt);

                // todo : 멀티셀렉트 창 닫기 (이거 지원안하는 거 같음.)

            },
        }
    }
</script>

